import { Layout } from "antd";
import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FetchContext from "../../contexts/fetch";
import FlowContext from "../../contexts/flowContext";
import SidebarContext from "../../contexts/sidebar";
import UserContext from "../../contexts/user";
import Flow from "../Flow";
import WebAppPreview from "../Simulation/WebApp/Preview";
import styles from "./home.module.css";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import UrlParameters from "./UrlParameters";

const { Header, Sider, Content } = Layout;

const Home = () => {
  const navigate = useNavigate();

  const [fetchState, fetchDispatcher] = useContext(FetchContext);
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [userState, userDispatcher] = useContext(UserContext);
  const [sidebarState] = useContext(SidebarContext);

  const params = useParams();

  const getFlowByNameAndVersion = (app, brand, flowName, version) => {
    let flow = null;
    try {
      flow =
        fetchState.flows
          ?.filter((flow) => flow.brand === brand)[0]
          ?.transformed_flows[flowName].filter(
            (flow) => flow.version === version
          )[0] || null;
    } catch (e) {
      flow = null;
    }
    return flow;
  };

  useEffect(() => {
    // when component mounts, fetch the flow list and set up url params
    const { app, brand, flowName, version } = params;

    if (app) {
      fetchDispatcher({
        type: "fetch-flow-list",
        app,
      });
      if (["call-bot", "web-app", "allo-brain"].includes(app)) {
        userDispatcher({
          type: "change-app",
          app,
        });
      }
    }

    if (app && brand) {
      userDispatcher({
        type: "change-app",
        app,
      });
      userDispatcher({
        type: "change-brand",
        brand,
      });
      userDispatcher({
        type: "change-version",
        version,
      });
      userDispatcher({
        type: "change-flow-name",
        flowName,
      });
    }
  }, []);

  useEffect(() => {
    if (fetchState.flows && fetchState.flows.length > 0) {
      let flow = getFlowByNameAndVersion(
        userState.currentApp,
        userState.currentBrand,
        userState.currentFlowName,
        userState.currentVersion
      );
      if (!flow) {
        flow = getFlowByNameAndVersion(
          flowState.app,
          flowState.brand,
          flowState.name,
          flowState.version
        );
      }

      if (flow) {
        navigate(`../${flow.app}/${flow.brand}/${flow.name}/${flow.version}`, {
          replace: true,
        });

        fetchDispatcher({
          type: "fetch-flow-status",
          app: flow.app,
          brand: flow.brand,
          flowName: flow.name,
          flowId: flow._id,
        });

        flowDispatcher({
          type: "update-flow",
          flow,
        });
      } else {
        flow = localStorage.getItem("duplicated-flow");

        if (flow) {
          flowDispatcher({
            type: "update-flow",
            flow: JSON.parse(flow),
          });
        }
        localStorage.removeItem("duplicated-flow");
      }
    }
  }, [fetchState.flows]);

  useEffect(() => {
    const { app, brand, flowName, version } = params;

    if (app && brand && flowName && version) {
      /* flowDispatcher({
        type: "clear-flow",
      });

      const flow = getFlowByNameAndVersion(app, brand, flowName, version);
      flowDispatcher({
        type: "update-flow",
        flow: {
          ...flow,
          app,
          brand,
          name: flowName,
          version,
        },
      }); */
      userDispatcher({
        type: "change-app",
        app,
      });
      userDispatcher({
        type: "change-brand",
        brand,
      });
      userDispatcher({
        type: "change-flow-name",
        flowName,
      });
      userDispatcher({
        type: "change-version",
        version,
      });
    }
  }, [
    params.app,
    params.brand,
    params.flowName,
    params.version,
    fetchState.flows,
  ]);

  useEffect(() => {
    if (userState.currentBrand) {
      fetchDispatcher({
        type: "fetch-client-config",
        brand: userState.currentBrand,
        app: userState.currentApp,
      });
    }
  }, [userState.currentBrand]);

  return (
    <Layout className={styles.home_container}>
      <Sider
        className={styles.sidebar}
        width={0}
        collapsedWidth={0}
        trigger={null}
        collapsible
        collapsed={!sidebarState.active}
      >
        {/*<Sidebar/>*/}
      </Sider>
      <Sidebar />
      <Layout>
        <Header className={styles.header}>
          <Navbar />
        </Header>
        <Content className={styles.content}>
          <Flow />
        </Content>
      </Layout>

      <UrlParameters />

      {params.app === "web-app" && <WebAppPreview />}
    </Layout>
  );
};

export default Home;
